import { render, staticRenderFns } from "./FlexibleSpec.vue?vue&type=template&id=6908ddd4&scoped=true"
import script from "./FlexibleSpec.vue?vue&type=script&lang=js"
export * from "./FlexibleSpec.vue?vue&type=script&lang=js"
import style0 from "./FlexibleSpec.vue?vue&type=style&index=0&id=6908ddd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6908ddd4",
  null
  
)

export default component.exports